import { useEffect } from 'react';
import { planHasWatermark } from 'fym-shared/src/music24/watermarkUpsell';
import { useMusic24Plan } from '../hooks/useMusic24Plan';
import { rememberPaymentWatermarkSummary } from './paymentWatermarkSummary';
import { useWatermarkSummary } from './useWatermarkSummary';

/**
 * Keeps each answer of the watermark summary for the payment return page
 * (`paymentWatermarkSummary`), while the plan has the watermark. A paid plan stores nothing, so the
 * zeros of after the payment do not replace the numbers of before it. Mount it one time
 * (`WatermarkUpsellHost`).
 */
export function useRememberWatermarkSummary(): void {
  const plan = useMusic24Plan();
  const { summary, isLoaded } = useWatermarkSummary();
  const { files, cleanCopiesAvailable } = summary;
  useEffect(() => {
    if (isLoaded && planHasWatermark(plan)) {
      rememberPaymentWatermarkSummary({ files, cleanCopiesAvailable });
    }
  }, [isLoaded, plan, files, cleanCopiesAvailable]);
}
